// Copyright (c) 2017 Deere & Company

import {mapSearchRoutes} from '../shared/services/home-page-helper-sap-down';
import {routerActions} from 'react-router-redux';

export const onSearchSapDown = (searchBy, query) =>
    dispatch => {

        dispatch(routerActions.push(mapSearchRoutes(searchBy, query)));

    };



// WEBPACK FOOTER //
// ./src/home-page/action-creators/search-sap-down.js